// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__BaseArtist from "./baseArtist.jsx";
import * as Subsonic__Response from "./response.jsx";

function indexItem_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.artist;
  const v$1 = x.name;
  return {
    artist: v !== undefined ? Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__BaseArtist.of_json, v) : Ppx_deriving_json_runtime.of_json_error("missing field \"artist\""),
    name: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"name\"")
  };
}

function indexItem_to_json(x) {
  return {
    artist: Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__BaseArtist.to_json, x.artist),
    name: x.name
  };
}

function artists_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.index;
  return {
    index: v !== undefined ? Ppx_deriving_json_runtime.Primitives.array_of_json(indexItem_of_json, v) : Ppx_deriving_json_runtime.of_json_error("missing field \"index\"")
  };
}

function artists_to_json(x) {
  return {
    index: Ppx_deriving_json_runtime.Primitives.array_to_json(indexItem_to_json, x.index)
  };
}

function body_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.status;
  let tmp;
  if (v !== undefined) {
    const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(v);
    tmp = tag === "ok" ? "ok" : Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  } else {
    tmp = Ppx_deriving_json_runtime.of_json_error("missing field \"status\"");
  }
  const v$1 = x.artists;
  return {
    status: tmp,
    artists: v$1 !== undefined ? artists_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"artists\"")
  };
}

function body_to_json(x) {
  return {
    status: "ok",
    artists: artists_to_json(x.artists)
  };
}

function of_json(x) {
  return Subsonic__Response.of_json(body_of_json, x);
}

function to_json(x) {
  return Subsonic__Response.to_json(body_to_json, x);
}

export {
  indexItem_of_json,
  indexItem_to_json,
  artists_of_json,
  artists_to_json,
  body_of_json,
  body_to_json,
  of_json,
  to_json,
}
/* No side effect */
